module.exports = __webpack_public_path__ + "img/logo.9e9e8874.png";